const scheduleState = (state) => state.schedule

export const scheduleSelectors = {
    items: (state) => scheduleState(state).items,
    total: (state) => scheduleState(state).total,
    isLoading: (state) => scheduleState(state).isLoading,
    error: (state) => scheduleState(state).error,
    saveLoading: (state) => scheduleState(state).saveLoading,
    deleteLoading: (state) => scheduleState(state).deleteLoading,
    occupancyItems: (state) => scheduleState(state).occupancy.items,
    occupancyLoading: (state) => scheduleState(state).occupancy.isLoading,
}
